module.exports = __webpack_public_path__ + "b315b38f7e5b89034b4f9ae84caf8754.svg";